import { render } from "./ContentTextBlock.vue?vue&type=template&id=c11648fc&scoped=true&ts=true"
import script from "./ContentTextBlock.vue?vue&type=script&lang=ts"
export * from "./ContentTextBlock.vue?vue&type=script&lang=ts"

import "./ContentTextBlock.vue?vue&type=style&index=0&id=c11648fc&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c11648fc"]])

export default __exports__